// activityTradeExpert
export default {
  routerTitle: '盈宝港美股交易达人',
  shareTitle: '盈宝港美股交易达人，尊享高达HKD600奖励！',
  shareDesc: '交易即享福利，限时抢！',

  tradeCount: '交易港/美股笔数',
  tradeUnit: '笔',
  tradeUnitMore: '笔以上',
  stockUnit: '股',
  joinNow: '马上参与',

  cardOneTitle: '活动期内交易达标，即可获得奖励',
  cardOneDesc: '每个客户最多可获得其中一份奖励',
  cardOneTips: '注：奖励将在活动结束后系统校验交易笔数，自动发放。',

  wbYsTitle: '盈宝优势',
  wbDtYsDesc11: '多品种交易',
  wbDtYsDesc12: '支持港股，美股，牛熊涡轮界内证，ETF',
  wbDtYsDesc21: '杠杆放大可能',
  wbDtYsDesc22: '20倍港美股日内融，放大投资机会',
  wbDtYsDesc31: '低利息成本',
  wbDtYsDesc32: '孖展利息低至5.6%，降低投资成本',
  wbDtYsDesc41: '会员特权',
  wbDtYsDesc42: 'V3会员专享0元佣金，交易1亿港元仅需5元平台费',
  wbDtYsDesc51: '智能网格交易',
  wbDtYsDesc52: '条件单、止损止盈，策略在手，交易我有',

  rule: `<span>活动规则：</span><br/>
    1、活动时间：{time} <br/>
    2、活动奖励：<br/>
    2.1 活动交易奖励仅限港/美股交易为资格计算种类。（港/美股交易不包含新股、货币基金、日内融、投资组合产品）。<br/>
    2.2 活动期间每个客户最多可获得其中一份交易奖励。若用户活动期间交易101笔或以上，将自动获取价值高的奖励进行发放。注: 交易额奖励不可重复。<br/>
    2.3 交易笔数要求：港/美股交易中，买卖各算一笔。交易须在活动期间（北京时间）内完成成交，超出活动时间的交易不计入交易笔数。<br/>
    2.4 特殊渠道不参与此活动，详情可咨询在线客服。<br/>
    3、奖励发放说明：<br/>
    3.1 关于股票卡奖励：股票卡需满足对应的交易笔数要求，需在活动结束进行校验最终达标笔数，系统会自动发放股票卡券至个人账户，<span>卡券有效期为30天</span>。可前往我的卡券查看，逾期未兑换，不另补发。<br/>
    3.2 交易数据同步至卡券系统有1个交易日延时，请在完成符合指定条件的订单后下一个交易日再查看使用。<br/>
    3.3 卡券使用说明最终以“我的卡券”中为准。`,

  disclaimers: `<span>免责声明：</span><br/>
    1、活动奖励均严格按照规则发放，如有任何不符合活动获奖资格的情况，均无法特殊申请补发奖励，请遵守活动规则。特殊渠道用户不参与此活动。<br/>
    2、活动奖励设置有效期，若未在有效期内及时使用，过期后将不予以补发奖励，视为自动放弃获奖资格。<br/>
    3、如发现包括但不限于通过软件恶意刷奖、手机号码异常、盗取他人信息、邀请人IP异常等行为，盈宝证券有权取消或冻结其活动奖励。上述工作日均以中国香港法定工作日为准。<br/>
    4、此活动由盈宝证券（香港）有限公司提供。 本活动并非及不应被视为任何证券、金融产品或工具邀约、招揽、邀请、建议、意见或任何投资决策的建议，亦不应被视为专业意见。 浏览本活动的人士在作出任何投资决定之前，应完全了解其风险以及相关法律，涉及的税项及会计的特点及后果，并根据个人的情况决定投资是否适合个人的财政状况及投资目标，以及有关风险的承受能力，有需要时应寻找适当的专业意见。盈宝证券（香港）在法律规定范围内保留更改此条款及细则，更改或终止任何优惠的权利，而毋须另行通知。 本活动的奖励资格及数据确认，以盈宝证券（香港）后台数据为准，如有任何争议，盈宝证券（香港）保留最终解释权及决定权。<br/>
    5、苹果公司没有以任何方式参与比赛或抽奖，本活动与Apple inc无关。`
}
